import { Component } from '@angular/core';

import { DbService } from '../../db.service';
import { SpinnerService } from '../../spinner.service';

import { Boletim } from './_boletins.class';

@Component({
    selector: 'app-home-boletins',
    templateUrl: './_boletins.component.html',
    styleUrls: ['./_boletins.component.css']
})

export class Home_BoletinsComponent {
    lista_boletins: Boletim[] = [];

    constructor(
        private dbService: DbService,
        private spinnerService: SpinnerService
    ) {
        // Carrega lateral
        this.boletinsLoad();
    }

    fnAbrirPDF(url: string) {
        window.open('/assets/boletins/pdfs/' + url, '_blank');
    }

    boletinsLoad() {
        this.dbService.get<Boletim[]>('Boletim/GetUltimos4').subscribe(result => {
            // Encerra spinner
            this.spinnerService.stop();

            // Guarda objetos
            this.lista_boletins = result;
        });
    }
}
